import cx from "classnames";
import React from "react";
import {EModalMode} from "@components/elements/EModalMode";
import {Modal} from "@components/elements/Modal";
import {ModalHeader} from "@components/elements/ModalHeader";
import {ModalBody} from "@components/elements/ModalBody";
import {Overlay} from "@components/elements/Overlay";
import {AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineWarning} from "react-icons/ai";

export function ConfirmationModal(props: { isOpen: boolean, onClose: () => void, onConfirm: () => void }) {
    return (<Overlay
        fullScreen={true}
        z-index={100}
        className={cx("bg-gray-900 dark:bg-gray-900 bg-opacity-50 dark:bg-opacity-50", (!props.isOpen && "hidden"),)}>
        <Modal
            type={EModalMode.FIT_CONTENT}
            modalContainerClassName="min-w-[300px]"
            closeCrossSize={6}
            onClose={props.onClose}
        >
            <div className="flex flex-col w-full justify-start">
                <ModalHeader onClose={props.onClose} closeCrossSize={6}>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Are you sure?</h1>
                </ModalHeader>
                <ModalBody
                    className="flex flex-col gap-4">

                    <div
                        className={cx("flex bg-orange-100 dark:bg-orange-800 border-l-4 border-orange-500 dark:border-orange-500 text-orange-700 dark:text-orange-100 p-4", "rounded-2xl",)}>
                        <AiOutlineWarning className="h-5 w-5 flex-shrink-0 mt-0.5 mr-4"/>
                        <h2 className="text-lg font-medium text-gray-900 dark:text-gray-100">This will reset all
                            filters.</h2>
                    </div>


                    <div className="flex flex-row gap-4 justify-between">
                        {/* Cancel button with Icon */}
                        <button
                            className={cx("text-gray-600 dark:text-gray-400 ", "text-sm font-medium tracking-wider", "flex gap-2",)}
                            onClick={props.onClose}
                        >
                            <AiOutlineCloseCircle className="w-6 h-6"/>
                            Cancel
                        </button>
                        {/* Confirm button with Icon */}
                        <button
                            className={cx("text-red-600 dark:text-red-400 ", "text-sm font-medium tracking-wider", "flex gap-2",)}
                            onClick={props.onConfirm}
                        >
                            <AiOutlineCheckCircle className="w-6 h-6"/>
                            Confirm
                        </button>
                    </div>
                </ModalBody>
            </div>
        </Modal>
    </Overlay>);
}